module.exports = __webpack_public_path__ + "img/Uganda.6908252b.png";